// extracted by mini-css-extract-plugin
export default {"container":"kD-z","dimension":"lD-z","dimensionLabels":"mD-z"};